import { apiClient } from 'api/apiClient';
import type { TStockItem } from 'legacy/lib/api/types/StockItem';
import { fetchThumbnail } from 'legacy/templates/modules/stock-items/StockItemsService';

const RESOURCE = '/inventoryStocks';

const CHECK_INVENTORY = '/checkinventoryonhand';

export interface ICheckInventory {
	isOverCommitted: boolean;
	message: string;
}

export const getInventoryStocks = async (
	filter = '',
	withImages = false
): Promise<TStockItem[]> => {
	const { data } = await apiClient.get(`${RESOURCE}${filter}`.trim());
	const items = await Promise.all(
		data.map(async (item: TStockItem) => {
			if (withImages && item.primaryImageId) {
				const stockImage = await fetchThumbnail(item.primaryImageId);
				return { ...item, stockImage };
			}
			return item;
		})
	);
	return items;
};

export const getInventoryOnHand = async (
	filter: string
): Promise<ICheckInventory> => {
	const { data } = await apiClient.get(
		`${RESOURCE}${CHECK_INVENTORY}?${filter}`
	);
	return data;
};
